/**
 * convertit une variable "xxx_xx" en xxxXx
 */
export function txtCamelCase(snakeCaseStr: string) {
    return snakeCaseStr.replace(/_([a-z])/g, function (match, letter) {
        return letter.toUpperCase();
    });
}